var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _c(
          "div",
          {
            staticClass: "breadcrumbs ace-save-state",
            attrs: { id: "breadcrumbs" }
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "pcode" } } },
                  [_c("a", [_vm._v("個人コード一覧 ")])]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [
                  _vm._v("新規個人コード登録")
                ])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.errorMessageLogs !== ""
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errorMessageLogs) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.message
              ? _c("div", { staticClass: "alert alert-success" }, [
                  _vm._v("\n          " + _vm._s(_vm.message) + "\n        ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "form",
                  { staticClass: "form-horizontal", attrs: { role: "form" } },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-2 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [
                          _vm._v("個人コード "),
                          _c("font", { staticClass: "input-required" }, [
                            _vm._v("※必須")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pcodeInfor.pCodeId,
                              expression: "pcodeInfor.pCodeId"
                            }
                          ],
                          staticClass: "form-control input-sm",
                          attrs: {
                            type: "text",
                            id: "name",
                            placeholder: "個人コード"
                          },
                          domProps: { value: _vm.pcodeInfor.pCodeId },
                          on: {
                            blur: _vm.validateBeforeSubmit,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.pcodeInfor,
                                "pCodeId",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-2 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [_vm._v("コード種別")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-10" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pcodeInfor.type,
                                expression: "pcodeInfor.type"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { "data-placeholder": "ユーザー選択" },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.pcodeInfor,
                                    "type",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                _vm.validateBeforeSubmit
                              ]
                            }
                          },
                          _vm._l(_vm.listType, function(item) {
                            return _c(
                              "option",
                              {
                                key: item.value,
                                domProps: { value: item.value }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.text) +
                                    "\n                  "
                                )
                              ]
                            )
                          })
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", {
                        staticClass: "col-sm-2 control-label no-padding-right",
                        attrs: { for: "form-field-1" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-10" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn-cusstom green-btn",
                            attrs: {
                              type: "button",
                              href: "#userList",
                              "data-toggle": "modal"
                            }
                          },
                          [_vm._v("ユーザーの選択")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-cusstom black-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.removeUser()
                              }
                            }
                          },
                          [_vm._v("ユーザーの関連付け解除")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-2 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [_vm._v("ユーザーID")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pcodeInfor.userId,
                              expression: "pcodeInfor.userId"
                            }
                          ],
                          staticClass: "form-control input-sm",
                          attrs: {
                            type: "text",
                            id: "name",
                            disabled: "",
                            placeholder: "ユーザーID"
                          },
                          domProps: { value: _vm.pcodeInfor.userId },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.pcodeInfor,
                                "userId",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-2 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [_vm._v("ユーザー名")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pcodeInfor.name,
                              expression: "pcodeInfor.name"
                            }
                          ],
                          staticClass: "form-control input-sm",
                          attrs: {
                            type: "text",
                            id: "name",
                            disabled: "",
                            placeholder: "ユーザー名"
                          },
                          domProps: { value: _vm.pcodeInfor.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.pcodeInfor,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-2 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [_vm._v("ステータス")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-1" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pcodeInfor.isValid,
                              expression: "pcodeInfor.isValid"
                            }
                          ],
                          staticClass: "ace ace-switch ace-switch-4",
                          attrs: { name: "switch-field-1", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.pcodeInfor.isValid)
                              ? _vm._i(_vm.pcodeInfor.isValid, null) > -1
                              : _vm.pcodeInfor.isValid
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.pcodeInfor.isValid,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.pcodeInfor.isValid = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.pcodeInfor.isValid = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.$set(_vm.pcodeInfor, "isValid", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", {
                        staticClass: "col-sm-2 control-label no-padding-right",
                        attrs: { for: "form-field-1" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-10" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn cancel_bottom",
                              attrs: { to: { name: "pcode" } }
                            },
                            [
                              _vm._v(
                                "\n                  キャンセル\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info save_group_bottom",
                              attrs: { type: "button" },
                              on: { click: _vm.addPcodeConfirm }
                            },
                            [
                              _vm._v(
                                "\n                  保存\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "userList", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("×")]
              ),
              _vm._v(" "),
              _c(
                "h3",
                { staticClass: "smaller lighter frofile-title no-margin" },
                [_vm._v("ユーザーの関連付けを追加")]
              ),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-cusstom green-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.search()
                    }
                  }
                },
                [_vm._v("検索")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _vm.listUser != null
                ? _c(
                    "table",
                    {
                      staticClass:
                        "table  table-bordered table-hover dataTable",
                      attrs: { id: "simple-table" }
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _vm._l(_vm.listUser, function(item, index) {
                        return _c("tbody", { key: index }, [
                          _c("tr", [
                            _c("td", { staticClass: "center" }, [
                              _c("label", { staticClass: "pos-rel" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedUserId,
                                      expression: "selectedUserId"
                                    }
                                  ],
                                  staticClass: "ace",
                                  attrs: { type: "radio" },
                                  domProps: {
                                    value: item.userId,
                                    checked: _vm._q(
                                      _vm.selectedUserId,
                                      item.userId
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.selectedUserId = item.userId
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "lbl" })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(item.userId) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(item.name) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "center" }, [
                              item.isValid
                                ? _c("span", [_vm._v("有効")])
                                : _c("span", [_vm._v("無効")])
                            ])
                          ])
                        ])
                      })
                    ],
                    2
                  )
                : _c(
                    "table",
                    {
                      staticClass:
                        "table  table-bordered table-hover dataTable",
                      attrs: { id: "simple-table" }
                    },
                    [_vm._m(5), _vm._v(" "), _vm._m(6)]
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c("div", { staticClass: "row pd-t-10" }, [
                _vm.pages > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "dataTables_paginate paging_simple_numbers"
                      },
                      [
                        _c("paginate", {
                          attrs: {
                            "page-count": _vm.pages,
                            "page-range": 3,
                            "margin-pages": 2,
                            "click-handler": _vm.handleCurrentChange,
                            "prev-text": "<<",
                            "next-text": ">>",
                            "container-class": "pagination",
                            "page-class": "page-item"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-danger pull-right",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.addUserInfor()
                    }
                  }
                },
                [_vm._v("選択")]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "confirm", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(7),
            _vm._v(" "),
            _vm._m(8),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-green",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" }
                },
                [_vm._v("見直す")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-red",
                  staticStyle: { width: "250px" },
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.yesChoice()
                    }
                  }
                },
                [_vm._v("小文字が含まれていても登録する")]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("新規個人コード登録")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-offset-2 col-md-10" }, [
      _c("span", { staticClass: "error_m", attrs: { id: "name_error" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-icon search-box" }, [
      _c("input", {
        staticClass: "nav-search-input",
        attrs: {
          type: "text",
          placeholder: "ユーザーID、ユーザー名検索",
          id: "nav-search-input",
          autocomplete: "off"
        }
      }),
      _vm._v(" "),
      _c("i", { staticClass: "ace-icon fa fa-search nav-search-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ユーザーID")]),
        _vm._v(" "),
        _c("th", [_vm._v("ユーザー名")]),
        _vm._v(" "),
        _c("th", { staticClass: "center" }, [_vm._v("ステータス")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "150px" } }, [_vm._v("ユーザーID")]),
        _vm._v(" "),
        _c("th", [_vm._v("ユーザー名")]),
        _vm._v(" "),
        _c("th", { staticClass: "center" }, [_vm._v("ステータス")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tbody", [
      _c("tr", [
        _c("td", { attrs: { colspan: "3" } }, [_vm._v("データーはありません")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("個人コード登録")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("div", [
        _vm._v(
          "\n            カード番号に半角英字の小文字が含まれております。"
        ),
        _c("br"),
        _vm._v(
          "\n            小文字が含まれているとカードが正常に読み込まれません。"
        ),
        _c("br"),
        _vm._v(
          "\n            小文字が含まれているかを確認してください。\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c661230", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c661230","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pcode/PcodeAdd.vue
// module id = null
// module chunks = 